// @flow
import React, { Component } from 'react';
import { MdRemoveCircle } from 'react-icons/md';
import PerfectScrollbar from 'perfect-scrollbar';
import './InputBadges.scss';

type Props = {
  badges: string[],
  onInsert(string): void,
  onRemove(string): void,
};

type State = {
  input: string,
};

// const processBadges = (badges: Array<string>): Array<string> => {
//   let processed = badges.map(badge => badge.trim()) // trim the text
//     .filter(badge => badge !== ''); // remove empty ones
//   processed = uniqBy(badges); // remove duplicates;
//   return processed;
// };

const Badge = ({ name, onRemove }) => (
  <div className="badge">
    <div className="text">{name}</div>
    <div className="remove" onClick={() => onRemove(name)}>
      <MdRemoveCircle />
    </div>
  </div>
);

class InputBadges extends Component<Props, State> {
  static defaultProps = {
    badges: ['태그1', '태그2', '태그3'],
  };
  badges: any = null;
  state = {
    input: '',
  };

  onChange = (e: any) => {
    this.setState({
      input: e.target.value,
    });
  };

  onKeyUp = (e: any) => {
    if (['Enter', ',', ' ', '_', '/', '|'].indexOf(e.key) !== -1) {
      this.onButtonClick();
      e.preventDefault();
    }
  };

  onButtonClick = () => {
    const { input } = this.state;
    const { onInsert } = this.props;
    onInsert(input);
    this.setState({
      input: '',
    });
  };

  renderBadges() {
    const { badges, onRemove } = this.props;
    return badges.map(badge => <Badge key={badge} name={badge} onRemove={onRemove} />);
  }

  componentDidMount() {
    const ps = new PerfectScrollbar(this.badges);
  }

  render() {
    const { onChange, onButtonClick, onKeyUp } = this;
    const { input } = this.state;

    return (
      <div className="InputBadges">
        <div className="input-button">
          <input
            placeholder="뱃지를 입력하세요"
            value={input}
            onChange={onChange}
            onKeyUp={onKeyUp}
          />
          <div className="badges-button util flex-center" onClick={onButtonClick}>
            등록
          </div>
        </div>
        <div
          id="badges"
          className="badges"
          ref={ref => {
            this.badges = ref;
          }}
        >
          {this.renderBadges()}
        </div>
      </div>
    );
  }
}

export default InputBadges;



// WEBPACK FOOTER //
// ./src/components/write/InputBadges/InputBadges.js